export default __webpack_public_path__ + "media/images/select2-spinner-203d1199e7aef04c0a347a0502248ee8.gif";